import { render, staticRenderFns } from "./MerchantTerminals.vue?vue&type=template&id=1876a363&scoped=true"
import script from "./MerchantTerminals.vue?vue&type=script&lang=js"
export * from "./MerchantTerminals.vue?vue&type=script&lang=js"
import style0 from "./MerchantTerminals.vue?vue&type=style&index=0&id=1876a363&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1876a363",
  null
  
)

export default component.exports